import getRetentionPolicyTagsForGroup from './getRetentionPolicyTagsForGroup';
import getSharedFolderPolicyTagList from 'owa-shared-folder/lib/selectors/getSharedFolderPolicyTagList';
import type { MailboxInfo } from 'owa-client-types';
import { getCoprincipalMailboxInfo } from 'owa-account-source-list-store';
import { getUserMailboxInfo } from 'owa-client-ids';
import { getAccountScopeUserSettings } from 'owa-session-store';
import type RetentionPolicyTag from 'owa-service/lib/contract/RetentionPolicyTag';
import type RecursiveReadOnly from 'owa-service/lib/RecursiveReadOnly';

export default function getRetentionPolicyTagListForMailboxInfo(
    mailboxInfo: MailboxInfo
): RecursiveReadOnly<RetentionPolicyTag[] | undefined> {
    if (mailboxInfo?.type === 'GroupMailbox') {
        const groupMailboxInfo = mailboxInfo;
        const coprincipalMailboxInfo =
            /* eslint-disable-next-line owa-custom-rules/no-default-methods  -- (https://aka.ms/OWALintWiki)
             * Methods that use the default mailbox should not be used, see https://aka.ms/multiaccountlinter
             *	> Do Not Use Default: The getUserMailboxInfo function should not be used for Respond multi-account support, user identity is not enough to identify account information. */
            getCoprincipalMailboxInfo(groupMailboxInfo) ?? getUserMailboxInfo();
        return getRetentionPolicyTagsForGroup(
            coprincipalMailboxInfo,
            groupMailboxInfo.mailboxSmtpAddress
        );
    }

    if (mailboxInfo?.type === 'SharedMailbox') {
        return getSharedFolderPolicyTagList(mailboxInfo.mailboxSmtpAddress);
    }

    return getAccountScopeUserSettings(mailboxInfo).RetentionPolicyTags;
}
